import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { logoApplication, maxLengthLitte } from '../../utils/dataApi/dataFormApi';
import { ROUTES } from '../../config/routingUrl';
import { useDispatch, useSelector } from 'react-redux';
import { UserConnexion } from '../../actions/request/UserRequest';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FETCH_CUSTOMER_SUCCESS, FETCH_USER_SUCCESS } from '../../app/actions/actions';
import HCaptcha from "@hcaptcha/react-hcaptcha"
import axios from 'axios';
import { baseurl } from '../../utils/url/baseurl';
import { Button, Form } from 'react-bootstrap';

const LoginPage = () => {
    const [showPassword, setShowPassword] = useState(false);
    const dispatch = useDispatch();
    const loadingUser = useSelector((state) => state.users.loadingUser);
    const navigate = useNavigate();
    const [captchaToken, setCaptchaToken] = useState(null); // Stocke le token du captcha
    const [selectedLanguage, setSelectedLanguage] = useState("fr"); // Langue sélectionnée
    const keayrecaptcha = baseurl.ApiKeyRecaptcha;

    useEffect(() => {
        dispatch({ type: FETCH_USER_SUCCESS });
        dispatch({ type: FETCH_CUSTOMER_SUCCESS });
    }, [dispatch])

    // Fonction appelée lorsque le captcha est résolu
    const onVerify = (token) => {
        setCaptchaToken(token); // Stocke le token généré par hCaptcha
        // console.log("Captcha Token:", token);
    };


    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .email('Adresse email invalide')
                .max(maxLengthLitte, `L\'adresse email ne peut pas dépasser ${maxLengthLitte} caractères`) // Limite à 100 caractères
                .required('Veuillez entrer votre email'),
            password: Yup.string()
                .min(4, 'Le mot de passe doit contenir au moins 8 caractères')
                .max(maxLengthLitte, `Le mot de passe ne peut pas dépasser ${maxLengthLitte} caractères`) // Limite à 50 caractères
                .required('Veuillez entrer votre mot de passe'),
        }),
        onSubmit: values => {
            if (!captchaToken) {
                toast.error("Veuillez valider le reCAPTCHA avant de continuer !", { position: "bottom-right" });
                return;
            }
            dispatch(UserConnexion(values.email, values.password, navigate, toast));
        },
    });

    return (
        <div className="page-content bg-white" style={{ padding: "70px 0px 70px 0px" }}>
            <section className="content-inner bg-white text-white py-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-8 col-md-10">
                            <div className="login-form bg-white p-4 rounded">
                                <form onSubmit={formik.handleSubmit}>
                                    <div className="text-center mb-4">
                                        {/*<img
                                            src={logoApplication}
                                            alt="Logo"
                                            className="img-fluid rounded-circle mb-3"
                                            style={{ width: '80px', height: '80px' }}
                                        /> */}
                                        <h2 className="h4">Se connecter</h2>
                                    </div>

                                    <div className="form-group mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input
                                            type="email"
                                            className={`form-control ${formik.touched.email && formik.errors.email ? 'is-invalid' : ''}`}
                                            id="email"
                                            name="email"
                                            placeholder="Entrez votre email"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.email}
                                            style={{
                                                fontSize: "16px",
                                                width: "100%",
                                                height: '40px',
                                                background: "#FFFFFF",
                                                borderRadius: "20px", // Bordures arrondies
                                                border: "1px solid black", // Bordure légère pour améliorer la visibilité
                                            }}
                                        />
                                        {formik.touched.email && formik.errors.email ? (
                                            <div className="invalid-feedback">{formik.errors.email}</div>
                                        ) : null}
                                    </div>

                                    <div className="form-group mb-3">
                                        <label htmlFor="password" className="form-label">Mot de passe</label>
                                        <div className="input-group"
                                        >
                                            <input style={{
                                                height: "40px",
                                                fontSize: "16px",
                                                width: "100%",
                                                height: '40px',
                                                background: "#FFFFFF",
                                                borderRadius: "20px", // Bordures arrondies
                                                border: "1px solid black", // Bordure légère pour améliorer la visibilité

                                            }}
                                                type={showPassword ? 'text' : 'password'}
                                                className={`form-control ${formik.touched.password && formik.errors.password ? 'is-invalid' : ''}`}
                                                id="password"
                                                name="password"
                                                placeholder="Entrez votre mot de passe"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.password}
                                            />

                                            {formik.touched.password && formik.errors.password ? (
                                                <div className="invalid-feedback">{formik.errors.password}</div>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="col-md-12 form-group d-flex justify-content-center">
                                        <Form>
                                            <Form.Check
                                                type="checkbox"
                                                id="prestataireCheck"
                                                label="Voir mot de passe"
                                                name="isPrestataire"
                                                checked={showPassword}
                                                onChange={(e) => { setShowPassword(e.target.checked) }}
                                                className="text-dark"
                                            />
                                        </Form>
                                    </div>

                                    <div className="d-flex justify-content-center mb-3">
                                        <span className="text-dark">Mot de passe oublié ?</span> <span><a href="#" onClick={() => navigate(`/${ROUTES.FORGETPASSWORDHASH}`)} >Cliquez ici </a></span>
                                    </div>

                                    <div className="col-md-12 form-group d-flex justify-content-center">
                                        {/*<ReCAPTCHA
                                                        sitekey={keayrecaptcha} // Remplacez par votre clé reCAPTCHA
                                                        onChange={setRecaptchaValue}
                                                    />*/}
                                        <HCaptcha
                                            // sitekey="a4064d96-aed6-4a86-80a2-c1f2b434ace4" // Remplacez par votre clé de site hCaptcha
                                            sitekey={keayrecaptcha} // Remplacez par votre clé de site hCaptcha
                                            onVerify={onVerify} // Appelée lorsque le captcha est résolu
                                            hl={selectedLanguage}
                                        />
                                    </div>

                                    <div className="d-flex justify-content-center">
                                        <div>
                                        <Button
                                            type="submit"
                                            className=" justify-content-center rounded-4"
                                            disabled={loadingUser}
                                            style={{
                                                textAlign: "center",
                                                width: "100%",
                                                height: '40px',
                                                border: "1px solid white", // Bordure légère pour améliorer la visibilité
                                                borderRadius: "25px",
                                                padding: "20px 50px 20px 50px",
                                                fontSize: "16px",
                                                fontWeight: "bold",
                                                gap: "8px",
                                                background: "#43B613",
                                                color:'white',
                                                display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                            }}
                                        >
                                            {loadingUser ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Chargement...
                                                </>
                                            ) : (
                                                'Connexion'
                                            )}
                                        </Button>
                                        </div>
                                    </div>

                                    <div className="text-center mt-3">
                                        <p className="mb-3 text">
                                            <span className="text-dark">Si vous n{"'"}avez pas de compte client , </span>
                                            <Link to={`/${ROUTES.SIGNUP}`} className="text-primary">
                                                <strong> S{"'"}inscrire ici </strong>
                                            </Link>
                                        </p>
                                        <p className="mb-0 text">
                                            <span className="text-dark">Si vous n{"'"}avez pas de compte d{"'"}agence de réservation</span>
                                            <Link to={`/${ROUTES.SIGNUP_PRESTATAIRE}`} className="text-primary">
                                                <strong> S{"'"}inscrire ici </strong>
                                            </Link>
                                        </p>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default LoginPage;
